import { ActionType } from './action.type';

export abstract class AbstractAction {
  abstract type(): ActionType;
}
